import { useMemo } from "react";
import {
  Badge,
  Container,
  Dropdown,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import MDFeCode from "./MDFe.Code";
import { getLabel } from "src/hook/Functions";
import DatePicker from "react-datepicker";
import { NavDatePicker } from "src/componentes/NavDatePicker/NavDatePicker.Component";
import moment from "moment";
import MDFeModalPropriedadesView from "./Modal.Propriedades/MDFe.Modal.Propriedades.View";
import MDFeModalNovoView from "./Modal.Novo/MDFe.Modal.Novo.View";
import MDFeModalNaoEncerradosView from "./Modal.NaoEncerrados/MDFe.Modal.NaoEncerrados.View";
import {
  EStatusEnvioMDFe,
  EUnidadeMedidaPesoMDFe,
  getDescricaoStatusEnvioMDFe,
  getVisualStatusMDFe,
  statusEnvioMDFeOptions,
} from "./MDFe.Dto";

const MDFeView = () => {
  const code = MDFeCode();

  const contadores = useMemo(() => {
    let naoEnviados = 0;
    let enviadosAbertos = 0;
    let enviadosEncerrados = 0;

    for (const item of code.data) {
      const s = Number(
        item.autorizacao?.codigoStatusEnvio ??
          (item as any).codigoStatusEnvio ??
          EStatusEnvioMDFe.Pendente
      );
      if (s === EStatusEnvioMDFe.Encerrado) {
        enviadosEncerrados++;
      } else if (
        s === EStatusEnvioMDFe.Autorizado ||
        s === EStatusEnvioMDFe.Transmitido ||
        item.autorizacao?.codigoStatusResposta === 100
      ) {
        enviadosAbertos++;
      } else if (
        s === EStatusEnvioMDFe.Pendente ||
        s === EStatusEnvioMDFe.Rejeitado
      ) {
        naoEnviados++;
      }
    }

    return { naoEnviados, enviadosAbertos, enviadosEncerrados };
  }, [code.data]);

  return (
    <>
      <Container>
        <HeadPage headText="MDF-e" onToggle={code.menu.handleMenuToggleClick}>
          {code.menu.menuItens !== undefined &&
            code.menu.menuItens.map((item) => (
              <Dropdown.Item
                key={item.nome}
                onClick={code.menu.handleMenuClick(item)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>

        {!code.loading ? (
          <>
            <Navbar className="bg-body-tertiary justify-content-between">
              <Container>
                <Navbar.Collapse className="justify-content-end">
                  <Nav className="ms-auto">
                    <Form.Control
                      placeholder="Série"
                      className="bg-body-tertiary"
                      onChange={code.handleChangeSerie}
                      value={
                        code.useFilter.filters.serie &&
                        code.useFilter.filters.serie > 0
                          ? code.useFilter.filters.serie.toString()
                          : ""
                      }
                    />

                    <Form.Control
                      placeholder="Placa"
                      className="bg-body-tertiary"
                      onChange={code.handleChangePlaca}
                      maxLength={7}
                      value={code.useFilter.filters.placa || ""}
                    />

                    <NavDropdown
                      onSelect={code.handleSelectStatus}
                      id="dropdown-codigoStatusEnvio"
                      title={getLabel(
                        statusEnvioMDFeOptions,
                        code.useFilter.filters.codigoStatusEnvio,
                        "Status Envio"
                      )}
                    >
                      {statusEnvioMDFeOptions.map((option) => (
                        <NavDropdown.Item
                          key={option.value}
                          eventKey={option.value}
                          active={
                            code.useFilter.filters.codigoStatusEnvio ===
                            option.value
                          }
                        >
                          {option.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>

                    <DatePicker
                      locale="pt-BR"
                      selected={code.useFilter.filters.dataEmissaoInicial}
                      onChange={code.handleSetDates}
                      startDate={code.useFilter.filters.dataEmissaoInicial}
                      endDate={code.useFilter.filters.dataEmissaoFinal}
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      withPortal
                      isClearable={true}
                      className="nav-datepicker"
                      title={code.getDatePickerTitle()}
                      customInput={<NavDatePicker />}
                    />
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>

            {/* Barra de Resumo e Filtro Rápido Visual dos Status */}
            <div className="d-flex align-items-center flex-wrap gap-2 my-2 px-1">
              <span className="small text-muted fw-semibold me-1">Status:</span>

              <button
                type="button"
                onClick={() => code.handleSelectStatus("99")}
                className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                  !code.useFilter.filters.codigoStatusEnvio ||
                  code.useFilter.filters.codigoStatusEnvio === "99"
                    ? "btn-dark text-white fw-semibold"
                    : "btn-outline-secondary"
                }`}
              >
                <span>Todos</span>
                <span className="badge bg-secondary rounded-pill ms-1">
                  {code.data.length}
                </span>
              </button>

              <button
                type="button"
                onClick={() => code.handleSelectStatus("1")}
                className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                  code.useFilter.filters.codigoStatusEnvio === "1"
                    ? "btn-warning text-dark fw-bold border border-warning"
                    : "btn-outline-warning text-body"
                }`}
                title="MDF-es que ainda não foram enviados ou autorizados pela SEFAZ"
              >
                <span>⏳ Não Enviados</span>
                <span className="badge bg-warning text-dark rounded-pill ms-1">
                  {contadores.naoEnviados}
                </span>
              </button>

              <button
                type="button"
                onClick={() => code.handleSelectStatus("4")}
                className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                  code.useFilter.filters.codigoStatusEnvio === "4"
                    ? "btn-success text-white fw-bold border border-success"
                    : "btn-outline-success text-body"
                }`}
                title="MDF-es autorizados na SEFAZ com viagem em andamento (aguardando encerramento)"
              >
                <span>🚚 Enviados Não Encerrados</span>
                <span className="badge bg-success text-white rounded-pill ms-1">
                  {contadores.enviadosAbertos}
                </span>
              </button>

              <button
                type="button"
                onClick={() => code.handleSelectStatus("6")}
                className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                  code.useFilter.filters.codigoStatusEnvio === "6"
                    ? "btn-secondary text-white fw-bold border border-secondary"
                    : "btn-outline-secondary text-body"
                }`}
                title="MDF-es que já tiveram a viagem concluída e foram encerrados na SEFAZ"
              >
                <span>✓ Enviados Encerrados</span>
                <span className="badge bg-secondary text-white rounded-pill ms-1">
                  {contadores.enviadosEncerrados}
                </span>
              </button>

              {code.useFilter.filters.codigoStatusEnvio &&
                code.useFilter.filters.codigoStatusEnvio !== "99" && (
                  <button
                    type="button"
                    onClick={() => code.handleSelectStatus("99")}
                    className="btn btn-sm btn-link py-0 px-2 text-decoration-none text-muted"
                  >
                    ✕ Limpar filtro
                  </button>
                )}
            </div>

            {code.data.length === 0 ? (
              <div className="text-center py-5 text-muted">
                Nenhum MDF-e encontrado para os filtros selecionados.
              </div>
            ) : (
              <Table responsive hover className="mt-2 no-border">
                <tbody>
                  {code.data.map((item) => {
                    const statusEnvio =
                      item.autorizacao?.codigoStatusEnvio ??
                      (item as any).codigoStatusEnvio ??
                      EStatusEnvioMDFe.Pendente;
                    const descricaoStatus = getDescricaoStatusEnvioMDFe(
                      statusEnvio,
                      item.autorizacao?.descricaoStatusEnvio ??
                        (item as any).descricaoStatusEnvio
                    );

                    const totalCTe =
                      item.quantidadeCTe !== undefined &&
                      item.quantidadeCTe !== null &&
                      Number(item.quantidadeCTe) > 0
                        ? Number(item.quantidadeCTe)
                        : (item.municipiosDescarga?.reduce(
                            (acc, m) =>
                              acc +
                              (m.documentos?.filter(
                                (d) => Number(d.tipoDocumento) === 1
                              ).length || 0),
                            0
                          ) ?? 0);

                    const totalNFe =
                      item.quantidadeNFe !== undefined &&
                      item.quantidadeNFe !== null &&
                      Number(item.quantidadeNFe) > 0
                        ? Number(item.quantidadeNFe)
                        : (item.municipiosDescarga?.reduce(
                            (acc, m) =>
                              acc +
                              (m.documentos?.filter(
                                (d) => Number(d.tipoDocumento) === 2
                              ).length || 0),
                            0
                          ) ?? 0);

                    const totalMDFe =
                      item.quantidadeMDFe !== undefined &&
                      item.quantidadeMDFe !== null &&
                      Number(item.quantidadeMDFe) > 0
                        ? Number(item.quantidadeMDFe)
                        : (item.municipiosDescarga?.reduce(
                            (acc, m) =>
                              acc +
                              (m.documentos?.filter(
                                (d) => Number(d.tipoDocumento) === 3
                              ).length || 0),
                            0
                          ) ?? 0);

                    const docsTexto = (() => {
                      const partes: string[] = [];
                      if (totalCTe > 0) partes.push(`${totalCTe} CT-e(s)`);
                      if (totalNFe > 0) partes.push(`${totalNFe} NF-e(s)`);
                      if (totalMDFe > 0) partes.push(`${totalMDFe} MDF-e(s)`);
                      return partes.length > 0 ? partes.join(" / ") : "0 Documentos";
                    })();

                    const pesoValor =
                      item.pesoBrutoTotal !== undefined &&
                      item.pesoBrutoTotal !== null &&
                      !isNaN(Number(item.pesoBrutoTotal)) &&
                      Number(item.pesoBrutoTotal) > 0
                        ? Number(item.pesoBrutoTotal)
                        : null;

                    const unidadeTexto =
                      Number(item.unidadeMedidaPeso) ===
                        EUnidadeMedidaPesoMDFe.TON ||
                      (item.unidadeMedidaPeso as any) === "TON"
                        ? "TON"
                        : "KG";

                    const valorCargaTexto =
                      item.valorTotalCarga !== undefined &&
                      item.valorTotalCarga !== null &&
                      !isNaN(Number(item.valorTotalCarga))
                        ? Number(item.valorTotalCarga).toLocaleString("pt-BR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "0,00";

                    const visual = getVisualStatusMDFe(
                      statusEnvio,
                      item.autorizacao?.codigoStatusResposta
                    );

                    return (
                      <tr
                        key={item.id ?? item.numeroMDFe}
                        style={{ cursor: "pointer" }}
                        onClick={code.handleClickPropriedades(item)}
                      >
                        <td colSpan={5} className="p-0">
                          <div className="border rounded p-2 mb-2">
                            <div className="d-flex align-items-center flex-wrap">
                              <div className="flex-grow-0 me-3">
                                <Badge
                                  bg={visual.badgeBg}
                                  text={visual.badgeText}
                                  className="px-2 py-1 fs-7 fw-semibold d-inline-flex align-items-center gap-1 shadow-sm"
                                >
                                  <span>{visual.iconSymbol}</span>
                                  <span>{visual.label}</span>
                                </Badge>
                              </div>

                              <div className="flex-grow-0 me-3 fw-bold">
                                MDF-e: {item.numeroMDFe}
                              </div>

                              <div className="flex-grow-0 me-3">
                                Série: {item.serie}
                              </div>

                              <div className="flex-grow-0 me-3">
                                Placa: {item.placaVeiculoTracao}
                              </div>

                              <div className="flex-grow-1 text-truncate me-3">
                                Sefaz: {statusEnvio}-{descricaoStatus}
                              </div>

                              {item.autorizacao?.codigoStatusResposta && (
                                <div className="flex-grow-1 text-truncate d-none d-md-block me-3">
                                  {item.autorizacao.codigoStatusResposta}-
                                  {item.autorizacao.descricaoMotivoResposta}
                                </div>
                              )}

                              <div className="ms-auto text-end">
                                Emissão:{" "}
                                {item.emissaoDataHora
                                  ? moment(item.emissaoDataHora).format(
                                      "DD/MM/YYYY HH:mm:ss"
                                    )
                                  : "-"}
                              </div>

                              <div className="w-100 my-1"></div>

                              <div className="flex-grow-1">
                                <small className="text-muted">Percurso</small>
                                <div className="text-body fw-medium">
                                  {item.ufInicio} ➔ {item.ufFim}
                                </div>
                              </div>

                              <div className="flex-grow-1">
                                <small className="text-muted">
                                  Documentos / Carga
                                </small>
                                <div className="text-body fw-medium">
                                  {docsTexto}
                                  {pesoValor !== null && (
                                    <>
                                      {" | "}
                                      {pesoValor.toLocaleString("pt-BR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 4,
                                      })}{" "}
                                      {unidadeTexto}
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="text-end">
                                <small className="text-muted">
                                  Valor da Carga
                                </small>
                                <div className="text-body fw-medium">
                                  R$ {valorCargaTexto}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </>
        ) : (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Container>

      <MDFeModalPropriedadesView
        show={code.modalShowPropriedades}
        mdfe={code.mdfe}
        onReturn={code.onReturnModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
        onDownloadXml={code.onDownloadXml}
        onFetchStatus={code.onFetchStatusModalPropriedades}
        onSend={code.onSendModalPropriedades}
        onEdit={code.onEditModalPropriedades}
        onDuplicate={code.onDuplicateModalPropriedades}
        onPrint={code.onPrintModalPropriedadesImprimir}
        onDownloadDamdfe={code.onModalPropriedadesDownloadDamdfe}
        onShareDamdfe={code.onModalPropriedadesShareDamdfe}
        onEvent={code.onEventModalPropriedades}
        onEncerrar={code.onEncerrarModalPropriedades}
        onVisualizar={code.onVisualizarModalPropriedades}
      />

      <MDFeModalNovoView
        show={code.modalNovoShow}
        onContinuar={code.onContinuarModalNovo}
        onCriarNovo={code.onCriarNovoModalNovo}
        onCancel={code.onCancelModalNovo}
      />

      <MDFeModalNaoEncerradosView
        show={code.modalNaoEncerradosShow}
        onClose={() => code.setModalNaoEncerradosShow(false)}
        onEncerrar={code.onEncerrarFromNaoEncerrados}
      />
    </>
  );
};

export default MDFeView;
